// src/routes/programsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Programs from '../pages/programs/Programs';
import CreateProgram from '../pages/programs/CreateProgram';
import EditProgram from '../pages/programs/EditProgram';
import ShowProgram from '../pages/programs/ShowProgram'; // ✨ NEW
import JobOrders from '../pages/programs/JobOrders';
import ProtectedRoute from '../components/global/ProtectedRoute';


const programsRoutes = (
    <>
        {/* Programs List */}
        <Route
            path="/programs"
            element={
                <ProtectedRoute requiredPermission="programs_list">
                    <Programs />
                </ProtectedRoute>
            }
        />


        {/* Programs Archive */}
        <Route
            path="/programs/archive"
            element={
                <ProtectedRoute requiredPermission="programs_archive_list">
                    <Programs />
                </ProtectedRoute>
            }
        />


        {/* Create Program */}
        <Route
            path="/programs/create"
            element={
                <ProtectedRoute requiredPermission="programs_create">
                    <CreateProgram />
                </ProtectedRoute>
            }
        />


        {/* ✨ NEW: Show Program Details */}
        <Route
            path="/programs/:id"
            element={
                <ProtectedRoute requiredPermission="programs_show">
                    <ShowProgram />
                </ProtectedRoute>
            }
        />


        {/* Edit Program */}
        <Route
            path="/programs/:id/edit"
            element={
                <ProtectedRoute requiredPermission="programs_edit">
                    <EditProgram />
                </ProtectedRoute>
            }
        />

        {/* Job Orders */}
        <Route
            path="/programs/:id/job-orders"
            element={
                <ProtectedRoute requiredPermission="job_orders_list">
                    <JobOrders />
                </ProtectedRoute>
            }
        />
    </>
);


export default programsRoutes;
